<template lang="pug">
  .text-center
    .font-bebas.tracking-widest.text-bolt NOW LOADING
    .indicator.mt-8
      .indicator-base
      .indicator-light(:style="{width:loaded+'%'}")
</template>
<style lang="sass" scoped>
.indicator
  @apply relative
.indicator-base
  @apply h-1 rounded
  background-color: rgba(#000, 0.5)
  box-shadow: inset 0 1px 3px rgba(#000, 0.5)
.indicator-light
  @apply absolute inset-y-0 left-0 bg-bolt rounded
  box-shadow: theme("colors.bolt") 0 0 4px
  transition: width 0.2s
</style>
<script>
import { mapState } from "vuex";
export default {
  props: ["value"],
  data() {
    return {
      loaded: 0
    };
  },
  computed: {
    ...mapState("stage", ["stages"])
  },
  mounted() {
    const { stages } = this;
    stages.map(stage => {
      const image = new Image();
      image.onload = () => {
        this.loaded += (1 / stages.length) * 100;
      };
      image.src = stage.panoramicImageSrc;
    });
  },
  watch: {
    loaded(v) {
      if (v >= 100) {
        setTimeout(() => {
          this.$emit("input", false);
        }, 1000);
      }
    }
  }
};
</script>
